export function getLanguageContent(schema, langKey) {
  const content = schema[langKey] ?? schema["en"]; // fallback to "en" if undefined
  return content;
}
